// Admin > Template Types stores `settings` as a free-form JSON string. This is
// the typed view of the properties the app reads from it; anything absent or
// unparseable falls back to the defaults (features off).
export interface TemplateTypeSettings {
  /** Shows the Artifacts tab on the Evidence Gathering step. Hidden unless exactly `true`. */
  show_artifacts?: boolean;
  /**
   * Data Extraction starts with an empty list; documents are added per template tab only via the
   * "Select from Evidence Base" popup, and extraction runs only on them. Off unless exactly `true`.
   */
  extraction_select_from_evidence_base?: boolean;
  validation?: Array<{ rule: string; value: string; format_type?: string }>;
}

export function parseTemplateTypeSettings(settings: string | null | undefined): TemplateTypeSettings {
  if (!settings) return {};
  try {
    const parsed = JSON.parse(settings);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}
